import eighteen from "../img/img1.png";
import thirty from "../img/img2.png";
import fourty from"../img/img3.png";
import fifty from "../img/img4.png";

export const DATA = [
  { value: "18-29", image: eighteen },
  { value: "30-39", image: thirty },
  { value: "40-49", image: fourty },
  { value: "50+", image: fifty },
];
